export function containsCaseInsensitive(haystack: string, needle: string) {
    if (!haystack) {
        return false;
    }

    if (!needle) {
        return true;
    }

    return haystack.toLocaleLowerCase().includes(needle.trim().toLocaleLowerCase());
}